var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNearshop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/nearshop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 23 24 23 24 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_ico/nearshop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,8 L22,8 C20.896,8 20,7.104 20,6 L20,0.32 C20,0.143 20.143,0 20.32,0 L23.68,0 C23.857,0 24,0.143 24,0.32 L24,6 C24,7.104 23.104,8 22,8",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,8 L17,8 C15.896,8 15,7.104 15,6 L15,0.32 C15,0.143 15.143,0 15.32,0 L18.68,0 C18.857,0 19,0.143 19,0.32 L19,6 C19,7.104 18.104,8 17,8",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8 L12,8 C10.896,8 10,7.104 10,6 L10,0.32 C10,0.143 10.143,0 10.32,0 L13.68,0 C13.857,0 14,0.143 14,0.32 L14,6 C14,7.104 13.104,8 12,8",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,8 L7,8 C5.896,8 5,7.104 5,6 L5,0.32 C5,0.143 5.143,0 5.32,0 L8.68,0 C8.857,0 9,0.143 9,0.32 L9,6 C9,7.104 8.104,8 7,8",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,8 L2,8 C0.896,8 0,7.104 0,6 L0,0.32 C0,0.143 0.143,0 0.32,0 L3.68,0 C3.857,0 4,0.143 4,0.32 L4,6 C4,7.104 3.104,8 2,8",
    id: "Fill-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,16 L21,16 L21,11 L17,11 L17,16 Z M10,16 L14,16 L14,11 L10,11 L10,16 Z M3,16 L7,16 L7,11 L3,11 L3,16 Z M0,9 L0,23 L8,23 L8,18 L16,18 L16,23 L24,23 L24,9 L0,9 Z",
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearshop);
export default __webpack_public_path__ + "static/media/nearshop.8375cb7be78303799c468742c22a4011.svg";
export { ForwardRef as ReactComponent };